
// vertical step bar
export const NEXT_SIGNUP_STAGE = 'NEXT_SIGNUP_STAGE'
export const BACK_SIGNUP_STAGE = 'BACK_SIGNUP_STAGE'
export const NEXT_LOGIN_RECOVERY_STAGE = 'NEXT_LOGIN_RECOVERY_STAGE'
export const BACK_LOGIN_RECOVERY_STAGE = 'BACK_LOGIN_RECOVERY_STAGE'
